import { Component, inject } from "@angular/core";
import { ROUTE_ANIMATIONS_ELEMENTS, routeAnimations } from "@app/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";

@Component({
  selector: "app-setup-container",
  templateUrl: "./setup-container.component.html",
  styleUrls: ["./setup-container.component.scss"],
  animations: [routeAnimations],
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class SetupContainerComponent {
  private router = inject(Router);

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  resourceManagement = [
    { link: "./resources", text: "scheduler.setup.resources.title" },
    { link: "./team-list", text: "scheduler.setup.teams.title" },
    { link: "./planners", text: "scheduler.setup.planners.title" },
    { link: "./skills", text: "scheduler.setup.skills.title" },
    { link: "./zones", text: "scheduler.setup.zones.title" }
  ];
  schedulingManagement = [];
  systemManagement = [
    { link: "./webhook-list", text: "scheduler.setup.webhook-list.title" },
    { link: "./systemConfigs", text: "scheduler.setup.system.configs.title" }
  ];
  activeLink: string = "/setup/resourcing";

  constructor() {
    const router = this.router;

    this.activeLink = router.url;
  }
}
